import BillingV2Adapter from './billing-v2';

export default class BillingCompanyAdapter extends BillingV2Adapter {
  pathForType() {
    return 'companies';
  }
}
